// Sanjay // - 25/01/25
import { axiosGetAuthorize, axiosGetMultiParams, axiosPostAuthorize } from '../AxiosRequests';
import {
    USP_Master_BankInsertUpdate,
    USP_Master_BankSelectbyid,
    USP_Master_ExpenseAccountGroupInsertUpdate,
    USP_Master_ExpenseAccGroupCount,
    USP_Master_ExpenseAccountGroupSelectbyID,
    USP_Master_AccountHeadInsertUpdate,
    USP_Master_AccountHeadSelectbyID,
    USP_Master_AccountHeadSelect,
    USP_Master_ExpenseAccountGroupSelect,
    USP_Master_GeneralProductInsertUpdate,
    USP_Master_CountrySelectbyid,
    USP_Master_CountryInsertUpdate,
    GetAllDropdownForAccountMaster,
    USP_Master_StateSelectbyId,
    USP_Master_StateInsertUpdate,
    USP_Master_CityInsertUpdate,
    USP_Master_CitySelectbyId,
    USP_Master_ChequeBookInsertUpdate,
    USP_Master_ChequeBookSelectbyID,
    USP_Master_ChequeBookListSelectbyID,
} from '../ApiEndPoints';

export default class AccountMasterServices {

    // bank master
    async submitBankMaster(request) {
        return axiosPostAuthorize(USP_Master_BankInsertUpdate, request);
    }
    async getMasterBankSelectbyid(request) {
        return axiosGetAuthorize(USP_Master_BankSelectbyid, request);
    }
    async submitAccountGroupMaster(request) {
        return axiosPostAuthorize(USP_Master_ExpenseAccountGroupInsertUpdate, request);
    }
    async getMasterExpenseAccGroupCount(request) {
        return axiosGetAuthorize(USP_Master_ExpenseAccGroupCount, request);
    }
    async getMasterExpenseAccountGroupSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_ExpenseAccountGroupSelectbyID, request);
    }

    async submitAccountHeadMaster(request) {
        return axiosPostAuthorize(USP_Master_AccountHeadInsertUpdate, request);
    }
    async getMasterAccountHeadSelectbyID(request) {
        return axiosGetAuthorize(USP_Master_AccountHeadSelectbyID, request);
    }
    async getMasterAccountHeadSelect(request) {
        return axiosGetAuthorize(USP_Master_AccountHeadSelect, request);
    }
    async getMasterExpenseAccountGroupSelect(request) {
        return axiosGetAuthorize(USP_Master_ExpenseAccountGroupSelect, request);
    }
    async submitGeneralAccountHeadMaster(request) {
        return axiosPostAuthorize(USP_Master_GeneralProductInsertUpdate, request);
    }

    async getMasterCountrySelectbyid(request) {
        return axiosGetAuthorize(USP_Master_CountrySelectbyid, request);
    }
    async submitCountryMaster(request) {
        return axiosPostAuthorize(USP_Master_CountryInsertUpdate, request);
    }

    async getAllDropdownForAccountMaster(request) {
        return axiosGetMultiParams(GetAllDropdownForAccountMaster, request);
    }
    async getMasterStateSelectbyId(request) {
        return axiosGetAuthorize(USP_Master_StateSelectbyId, request);
    }
    async submitStateMaster(request) {
        return axiosPostAuthorize(USP_Master_StateInsertUpdate, request);
    }

    async getMasterCitySelectbyId(request) {
        return axiosGetAuthorize(USP_Master_CitySelectbyId, request);
    }
    async submitCityMaster(request) {
        return axiosPostAuthorize(USP_Master_CityInsertUpdate, request);
    }

    async getMasterChequeBookSelectbyId(request) {
        return axiosGetAuthorize(USP_Master_ChequeBookSelectbyID, request);
    }
    async getMasterChequeBookListSelectbyId(request) {
        return axiosGetAuthorize(USP_Master_ChequeBookListSelectbyID, request);
    }
    async submitChequeMaster(request) {
        return axiosPostAuthorize(USP_Master_ChequeBookInsertUpdate, request);
    }
}